<template>
  <div class="other_operate_modal" >
     
    <Modal    
          v-model="otherModal"
          :title="`【${houseDetail['房屋地址']}】业务操作`" 
            :width="screenWidth*0.8"
          @on-cancel="cancel">
          <div class="base-modal" v-if="otherModal">
       
            <div class="illustrate">  
              <Button type="primary" icon="ios-archive-outline" @click="changeIllustrate('预定')" :disabled="illustrate.name=='预定'">预定</Button>
              <Button type="primary" icon="ios-close-circle-outline" @click="changeIllustrate('出租')" :disabled="illustrate.name=='出租'">出租</Button>
              <Button type="primary" icon="ios-build-outline" @click="changeIllustrate('密码/指导价/空置')" :disabled="illustrate.name=='密码/指导价/空置'">密码/指导价/空置</Button> 
              <Button type="primary" icon="ios-archive-outline" @click="changeIllustrate('已出租')" :disabled="illustrate.name=='已出租'">已出租</Button>
              <Button type="primary" icon="ios-archive-outline" @click="changeIllustrate('修改上架时间')" :disabled="illustrate.name=='修改上架时间'">修改上架时间</Button>
        
            </div>
            
            <Alert> 当前业务【{{ illustrate.name }}】 说明：{{ illustrate.content }}</Alert> 
          
       
             <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='预定'">  
                 <Form :model="yd" ref="yd" :label-width="150" :rules="ydRuleValidate" style="margin-top:20px;">
                 
                 <Row>
                <Col span="12">
                  <FormItem label="租客姓名" prop="zkxm" >
                    <Input v-model="yd.zkxm"  placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="12">
                  <FormItem label="联系电话"  prop="lxdh">
                    <Input v-model="yd.lxdh" type="number"  placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                
              </Row> 
              <Row>
                <Col span="12">
                  <FormItem label="定金金额" prop="djje" >
                    <Input v-model="yd.djje" type="number"  placeholder="请输入..."></Input>
                  </FormItem>
                </Col> 
                <Col span="12">
                  <FormItem label="预定时间" prop="ydsj">
                    <DatePicker clearable format="yyyy-MM-dd"  type="date" placement="bottom-end" placeholder="请选择时间范围" style="width: 300px" @on-change="changeDateYdsj" />
                  </FormItem>
                </Col> 
                
              </Row> 

                 </Form>
                 <Row> 
                <Col span="20">   </Col>
                <Col span="4"><Button type="info"  @click="operate('yd')" style="width:200px;" >提交</Button>  </Col>
              </Row>
              <Alert style="margin-top: 10px;">预定相关凭证</Alert>   
                <Upload :action="uploadUrl"  
                :headers="{ 'Authorization': 'Bearer ' +token }"
                accept=".jpg,.jpeg,.png,.pdf"
                :on-success="(response, file, fileList) => uploadSuccess(response, file, fileList,currentData.id,'1_出房管理', '预定凭证',null,null)" 
                :show-upload-list="true" 
                max-size="100*1024" >
              <Button type="info" style="margin-left:20px;">新增附件</Button>
                </Upload>
            <Table border :columns="fjColums" :data="ydpzList" :max-height="400">

              <template #img="{ row, index } " >
                  <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                    
                    <img style="width:200px;height:200px;" :src="row.img" alt="">
                  </div>
                  <div v-else>仅支持图片预览</div>
                </template> 
                <template #action="{ row, index } " >
                  <div class="buttomGroup">
                    <div class="btn ck" @click="watchFile(row,'预定凭证')">查看</div>
                    <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'预定凭证')">下载</div> 
                    <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'预定凭证')">删除</div>
                  </div>
                </template> 
              </Table>
             </VuePerfectScrollbar>
            <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='出租'"> 
              <Form :model="cz" ref="cz" :label-width="150" :rules="czRuleValidate" style="margin-top:20px;">
                <Row>
                <Col span="24">
                  <FormItem label="房屋地址">
                    <Input v-model="houseDetail['房屋地址']" :disabled="true"  placeholder="请输入..."></Input>
                  </FormItem>
                </Col>   
              </Row> 
                 <Row>
                  <Col span="12">
                    <FormItem label="租客姓名" prop="zkxm" >
                      <Input v-model="cz.zkxm"  placeholder="请输入..."></Input>
                    </FormItem>
                  </Col> 
                  <Col span="12">
                    <FormItem label="联系电话"  prop="lxdh">
                      <Input v-model="cz.lxdh" type="number"  placeholder="请输入..."></Input>
                    </FormItem>
                  </Col>  
                </Row> 
                <Row>
                  <Col span="12">
                    <FormItem label="开户行" >
                      <Input v-model="cz.khh"  placeholder="请输入..."></Input>
                    </FormItem>
                  </Col> 
                  <Col span="12">
                    <FormItem label="银行卡号" >
                      <Input v-model="cz.yhkh"   placeholder="请输入..."></Input>
                    </FormItem>
                  </Col>  
                </Row> 
                <Row>
                  <Col span="12">
                    <FormItem label="成交周期（天）" prop="cjzq" >
                      <InputNumber v-model="cz.cjzq" style="width:100%;"  placeholder="请输入..." /> 
                    </FormItem>
                  </Col> 
                  <Col span="12">
                    <FormItem label="出房渠道"  prop="cfqd">
                      <Select v-model="cz.cfqd" placeholder="请选择..." @on-change="filterStoreUser">
                          <Option v-for="item in ['中介','外网','老客户介绍','客户转租','续租','客户换房','其他']"  :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem>
                  </Col>  
                </Row> 
                <Row>
                  <Col span="12">
                    <FormItem label="出房费用（元）" prop="cffy" >
                      <InputNumber v-model="cz.cffy" style="width:100%;"  placeholder="请输入..." />
                    </FormItem>
                  </Col> 
                  <Col span="12">
                    <FormItem label="出房押金（元）" prop="cjyj" >
                      <InputNumber v-model="cz.cfyj"  style="width:100%;"   placeholder="请输入..." />
                    </FormItem>
                  </Col>  
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="合同起始日" prop="ht_start">
                    <DatePicker clearable format="yyyy-MM-dd" v-model="cz.ht_start"  type="date" placement="bottom-end" placeholder="请选择日期" style="width:100%;" @on-change="changeDateHtqsr" />
                  </FormItem>
                  </Col> 
                  <Col span="12">
                    <FormItem label="合同到期日" prop="ht_end">
                    <DatePicker clearable format="yyyy-MM-dd" v-model="cz.ht_end"  type="date" placement="bottom-end" placeholder="请选择日期" style="width:100%;" @on-change="changeDateHtdqr" />
                  </FormItem>
                  </Col>  
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="出房租金(不含物业费、宽带费)（元）" prop="cfzj" >
                      <InputNumber v-model="cz.cfzj" style="width:100%;"  placeholder="请输入..." />
                    </FormItem>
                  </Col> 
                  <Col span="12">
                    <FormItem label="租金支付周期" prop="zjzfzq" >
                      <Select v-model="cz.zjzfzq" placeholder="请选择..." @on-change="filterStoreUser">
                          <Option v-for="item in ['按季','按月','按半年','按年']"  :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem>
                  </Col>  
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="物业费、宽带费（元）" prop="wykdf" >
                      <InputNumber v-model="cz.wykdf" style="width:100%;"  placeholder="请输入..." />
                    </FormItem>
                  </Col> 
                  <Col span="12">
                    <FormItem label="物业费、宽带费支付周期" prop="wykdzfzq" >
                      <Select v-model="cz.wykdzfzq" placeholder="请选择..." @on-change="filterStoreUser">
                          <Option v-for="item in ['季付','年付']"  :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem>
                  </Col>  
                </Row>
                <Row>
                  <Col span="12">
                    <FormItem label="水电气押金（元）" prop="sdqyj" >
                      <InputNumber v-model="cz.sdqyj" style="width:100%;"  placeholder="请输入..." />
                    </FormItem>
                  </Col> 
                  <Col span="12">
                    <FormItem label="宠物押金" >
                      <InputNumber v-model="cz.cwyj" style="width:100%;"  placeholder="请输入..." />
                    </FormItem>
                  </Col>  
                </Row>
                <Row>
                  <Col span="24">
                    <FormItem label="特别约定"  >
                      <Input v-model="cz.tbyd" type="text"   placeholder="请输入..."></Input>
                    </FormItem>
                  </Col> 
                  
                </Row> 
                <Row>
                  <Col span="12">
                    <FormItem label="是否自用房"  >
                      <Select v-model="cz.sfzyf" placeholder="请选择..." @on-change="filterStoreUser">
                          <Option v-for="item in ['是','否']"  :key="item" :value="item">{{item}}</Option> 
                      </Select>
                    </FormItem>
                  </Col> 
                  
                </Row> 
                </Form>
                <Row align="middle" justify="end"> 
                  <Col span="20"></Col> 
                  <Col span="4"> <Button type="info"  @click="operate('cz')" style="width:200px;" >保存</Button> </Col> 
                </Row>
                <Alert style="margin-top:15px;">收款计划（请先保存出租相关信息再生成收款计划）</Alert>   
                <Row align="middle" justify="end"> 
                  <Col span="16"></Col> 
                  <Col span="4"> </Col>
                  <Col span="4"> <Button type="info"  @click="createFkjh(cz)" style="width:200px;" >生成收款计划</Button> </Col> 
                </Row>
      
                  <Form :model="newFkjh" ref="newFkjh" :label-width="150" :rules="czRuleValidate" style="margin-top:20px;">
                    <Row>
                      <Col span="6">
                        <FormItem label="付款时间" >
                        <DatePicker clearable format="yyyy-MM-dd"  type="date" placement="bottom-end" placeholder="请选择日期" style="width:100%;" @on-change="changeDateFksj" />
                      </FormItem>
                      </Col>  
                      <Col span="6">
                        <FormItem label="付款金额"  >
                          <InputNumber v-model="newFkjh.fkje" style="width:100%;"  placeholder="请输入..." />
                        </FormItem>
                      </Col> 
                      <Col span="6">
                        <FormItem label="第几次付款">
                          <InputNumber v-model="newFkjh.djcfk" style="width:100%;"  placeholder="请输入..." />
                        </FormItem>
                      </Col> 
                      <Col span="6">
                        <FormItem label="应收租金" >
                          <InputNumber v-model="newFkjh.yszj" style="width:100%;"  placeholder="请输入..." />
                      </FormItem>
                      </Col> 
                    </Row>
                    <Row>
                     
                      <Col span="6">
                        <FormItem label="应收宽带费/物业费"  >
                          <InputNumber v-model="newFkjh.kdwyf" style="width:100%;"  placeholder="请输入..." />
                        </FormItem>
                      </Col> 
                      <Col span="6">
                        <FormItem label="押金总额">
                          <InputNumber v-model="newFkjh.yj" style="width:100%;"  placeholder="请输入..." />
                        </FormItem>
                      </Col> 
                      <Col span="8"> </Col> 
                      <Col span="4"> <Button type="info"  @click="addNewFkjh()" style="width:200px;" >+新增</Button> </Col> 
                    </Row>
                  </Form>
                <Table border :columns="fkjhColums" :data="fkjhList" :max-height="400" style="margin-top: 10px;"> 
                
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn sc" style="margin-left:20px;" @click="deleteRowBeforePost(index)">删除</div>
                    </div>
                  </template> 
                </Table>
              
                <Alert style="margin-top:15px;">租客身份证信息</Alert>   

                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                 :on-success="(response, file, fileList) => uploadSuccess(response, file, fileList,currentData.id,'1_收房收款计划', '租客身份证信息',null,null)" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增租客身份证附件</Button>
                </Upload>
              <Table border :columns="fjColums" :data="zksfzList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'租客身份证信息')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'租客身份证信息')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'租客身份证信息')">删除</div>
                    </div>
                  </template> 
                </Table>
                <Upload :action="uploadUrl"  
                  :headers="{ 'Authorization': 'Bearer ' +token }"
                  accept=".jpg,.jpeg,.png,.pdf"
                 :on-success="(response, file, fileList) => uploadSuccess(response, file, fileList,currentData.id,'1_收房收款计划', '租房合同信息',null,null)" 
                  :show-upload-list="true" 
                  max-size="100*1024" >
                  <Button type="info" style="margin-left:20px;">新增租房合同附件</Button>
                </Upload>
              <Table border :columns="fjColums" :data="zfhtList" :max-height="400"> 
                <template #img="{ row, index } " >
                    <div style="width:200px;height:200px;margin:auto;" v-if="['jpg','jpeg','png'].includes(row.suffix)">
                      
                      <img style="width:200px;height:200px;" :src="row.img" alt="">
                    </div>
                    <div v-else>仅支持图片预览</div>
                  </template> 
                  <template #action="{ row, index } " >
                    <div class="buttomGroup">
                      <div class="btn ck" @click="watchFile(row,'租房合同信息')">查看</div>
                      <div class="btn tg" style="margin-left:20px;" @click="downloadFile(row,'租房合同信息')">下载</div> 
                      <div class="btn sc" style="margin-left:20px;" @click="deleteFileBefore(row,'租房合同信息')">删除</div>
                    </div>
                  </template> 
                </Table>
            
            </VuePerfectScrollbar>
            <VuePerfectScrollbar :style="{ 'display': 'block','height':screenHeight*0.6+'px' ,'overflow':'auto'}" v-if="illustrate.name==='收款计划和明细'">
            
            </VuePerfectScrollbar>

         
            
          
          </div>
          <template #footer>
                <div></div> 
            </template>
    </Modal>

  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import RecursiveRenderer from '../line/line.vue';
import otherInfo from './components/other_info.vue'
import {smwxMethod_9_001} from "@/api/9小程序管理/9_001_smwx"; 
import {zfglMethod_2_001} from "@/api/2租房管理/2_001_cxfy.js"; 
import {utilTools} from "@/utils/js/utilTools.js" 
import {fileMethod} from "@/api/files/fileMethod";
 import {userMethod}  from "@/api/login/user"
export default { 
  name:"base_detail_modal",
  comments:{VuePerfectScrollbar,RecursiveRenderer,otherInfo},
  props:{
    houseDetail:{
      type:Object,
      default:{},
    },
    currentData:{
      type:Object,
      default:{},
    },
    photoKeyList:{
      type:Array,
      default:[]
    },
    otherKeyList:{
      type:Array,
      default:[]
    },
    keyList:{
      type:Array,
      default:[]
    }
  },
    data() {
        return { 
          imgBaseUrl:"https://mp.xiaojiabiyu.net.cn/cms/v1/files/transform?uri=",
          
          uploadUrl:"/xjby/api/file/uploadHouseFiles",
          otherModal:false,//控制弹窗开关 
          keyNotShow:["id","clsId","dataFieldMap","ciSource","tVersion","ciStatus","viewId","tenant","data_field_map","_index","_rowKey","create_user",],
          illustrate:  {} ,//按钮说明
          //  {name:"补充信息",content:"补充其他信息。"}
          illustrateList:[
            {name:"预定",content:"填写预定相关信息"},
            {name:"出租",content:"填写出租相关信息"},
            {name:"收款计划和明细",content:"填写和补充收款计划以及明细"},
            {name:"密码/指导价/空置",content:"修改密码/指导价/总空置天数"},
            {name:"已出租",content:"修改状态为已出租"},
            {name:"修改上架时间",content:"修改上架时间信息"},
          ],
          // 照片表格
          fjColums:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          // 房间照片表格
          fjColums_v2:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '文件名', key: 'show_name', align: 'center'}, 
            {title: '房间', key: 'type_2', align: 'center'}, 
            {title: '预览', slot: 'img', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          // 空置
          kzColumn:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '房源地址', key: '房源地址', align: 'center'}, 
            {title: '合同起始日', key: '合同起始日', align: 'center'}, 
            {title: '合同到期日', key: '合同到期日', align: 'center'},
            {title: '空置天数', key: '空置天数', align: 'center'},
            {title: '操作', slot: 'action', width:120, align: 'center'}
          ],
            // 出租
            cczColumn:[
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '合同编号', key: '合同编号', align: 'center'}, 
            {title: '合同起始日', key: '合同起始日', align: 'center'}, 
            {title: '合同到期日', key: '合同到期日', align: 'center'},
            {title: '出房租金（元/月）', key: '出房租金', align: 'center'},
            {title: '业务状态', key: '业务状态', align: 'center'},
            {title: '出房人', key: '出房人', align: 'center'},
            {title: '出房门店', key: '出房门店', align: 'center'},
            {title: '操作', slot: 'action', width:120, align: 'center'}
          ],
          houseDetailShow:{},
          czImgList:[],//
          sfzImgList:[],
          fwtghtImgList:[],
          sqhtsImgList:[],
          fwImgList:[],
          //预定
          yd:{
            zkxm:"",//租客姓名
            lxdh:"",//联系电话
            djje:"",//定金金额
            ydsj:"",//预定时间
          },
          ydpzList:[],//预定凭证
          ydRuleValidate:{//预定验证
            zkxm: [ { required: true, message: '租客姓名不能为空', trigger: 'change' }  ],
            lxdh: [ { required: true, message: '联系电话不能为空', trigger: 'change' }  ],
            djje: [ { required: true, message: '定金金额不能为空', trigger: 'change' }  ],
            ydsj: [ { required: true, message: '预定时间不能为空', trigger: 'change' }  ],
            // sfr: [ { required: true, message: '收房人不能为空', trigger: 'change' } ],
                 
          },
          // 出租
          cz: {
            zkxm: 'ycl', // 租客姓名
            lxdh: '122', // 联系电话
            khh: '1231', // 开户行
            yhkh: '123123', // 银行卡号
            cjzq: 2, // 成交周期（天）
            cfqd: '中介', // 出房渠道
            cffy: 1500, // 出房费用（元）
            cjyj: 1500, // 出房押金（元）
            ht_start: '2025-04-14', // 合同起始日
            ht_end: '2026-04-13', // 合同到期日
            cfzj: 3000, // 出房租金(不含物业费、宽带费)（元）
            zjzfzq: '按季', // 租金支付周期
            wykdf: 50, // 物业费、宽带费（元）
            wykdzfzq: '季付', // 物业费、宽带费支付周期
            sdqyj: 110, // 水电气押金（元）
            cwyj: 25, // 宠物押金
            tbyd: '', // 特别约定
            sfzyf: '是' // 是否自用房
          },
          // cz: {
          //   zkxm: '', // 租客姓名
          //   lxdh: '', // 联系电话
          //   khh: '', // 开户行
          //   yhkh: '', // 银行卡号
          //   cjzq: 0, // 成交周期（天）
          //   cfqd: '中介', // 出房渠道
          //   cffy: 0, // 出房费用（元）
          //   cjyj: 0, // 出房押金（元）
          //   ht_start: '', // 合同起始日
          //   ht_end: '', // 合同到期日
          //   cfzj: 0, // 出房租金(不含物业费、宽带费)（元）
          //   zjzfzq: '按季', // 租金支付周期
          //   wykdf: 0, // 物业费、宽带费（元）
          //   wykdzfzq: '季付', // 物业费、宽带费支付周期
          //   sdqyj: 0, // 水电气押金（元）
          //   cwyj: 0, // 宠物押金
          //   tbyd: '', // 特别约定
          //   sfzyf: '是' // 是否自用房
          // },
          czRuleValidate:{
            zkxm: [
              { required: true, message: '租客姓名不能为空', trigger: 'blur' }
            ],
            lxdh: [
              { required: true, message: '联系电话不能为空', trigger: 'blur' },
             
            ],
            cjzq: [
              { required: true, message: '成交周期不能为空', trigger: 'blur' ,type:'number'}
            ],
            cfqd: [
              { required: true, message: '出房渠道不能为空', trigger: 'blur' }
            ],
            cffy: [
              { required: true, message: '出房费用不能为空', trigger: 'blur' ,type:'number'}
            ],
            cjyj: [
              { required: true, message: '出房押金不能为空', trigger: 'blur' ,type:'number'}
            ],
            ht_start: [
              { required: true, message: '合同起始日不能为空', trigger: 'blur' }
            ],
            ht_end: [
              { required: true, message: '合同到期日不能为空', trigger: 'blur' }
            ],
            cfzj: [
              { required: true, message: '出房租金不能为空', trigger: 'blur' ,type:'number'}
            ],
            zjzfzq: [
              { required: true, message: '租金支付周期不能为空', trigger: 'blur' ,}
            ],
            wykdf: [
              { required: true, message: '物业费、宽带费不能为空', trigger: 'blur' ,type:'number'}
            ],
            wykdzfzq: [
              { required: true, message: '物业费、宽带费支付周期不能为空', trigger: 'blur' }
            ],
            sdqyj: [
              { required: true, message: '水电气押金不能为空', trigger: 'blur',type:'number' }
            ],
          },
          zksfzList:[],//租客身份证附件
          zfhtList:[],//租房合同附件
          shfjList:[],
          recordList:[],//存储空置记录/出租记录
          detailRecord:{},//当前详情
          kzKey:["房源地址",'状态','状态','租房价格','操作时间','合同起始日','合同到期日','空置天数','操作人',],//详情的key
          czKey:["租客姓名","联系电话","开户行","银行卡号","出房人","出房门店","成交差价（元/月）","成交周期（天）","出房渠道","合同编号","合同起始日",
          "合同到期日","出房费用（元）","出房押金（元）","水电气押金","出房租金（元/月）","租金支付周期","物业/宽带费","物业/宽带费支付周期","违约收入","特别约定"],//详情的key
          ccjlSfzList:[],
          ccjlHtList:[],
          storeUserList:[],//门店用户
           //  收款计划相关
           fkjhColums:[//收款计划表格
            {title: '序号', type: 'index', width: 60, align: 'left', align: 'center'},
            {title: '付款时间',  sortable: true, key: 'fksj', align: 'center'}, 
            {title: '付款金额', key: 'fkje', align: 'center'},
            {title: '状态', key: 'zt', align: 'center'},
            {title: '第几次付款', key: 'djcfk', align: 'center'},
            {title: '操作', slot: 'action', width:300, align: 'center'}
          ],
          // 手动新增收款计划
          newFkjh:{
            fksj:"",//付款时间
            fkje:0,//付款金额
            djcfk:1,//第几次付款
            yszj:0,//应收押金
            kdwyf:0,//应收宽带费/物业费
            yj:0, //押金总额
          },
          fkjhList:[],//收款计划列表
          


        }
    },
    computed: {
      
        screenWidth() {
            return this.$screenWidth;
        },
        screenHeight() {
            return this.$screenHeight;
        },
    },
    mounted(){
      

  
    },
    created(){  
    


    },
   
    watch:{},
    methods:{
      changeIllustrate(name){
        this.illustrate=this.illustrateList.find((i)=>{return i.name===name})
        if(name==="预定"){
          this.cleanPhotoListV3("预定凭证","1_出房管理",this.currentData.id,"预定凭证",null,this.currentData)
          
        }
        else if(name==="出租"){
          this.cleanPhotoListV3("租客身份证信息","1_收房收款计划",this.currentData.id,"租客身份证信息",null,this.currentData)
          this.cleanPhotoListV3("租房合同信息","1_收房收款计划",this.currentData.id,"租房合同信息",null,this.currentData)
          // 初始化值
          let cz = {
            zkxm: this.currentData['租客姓名'] != null && this.currentData['租客姓名'] != undefined ? this.currentData['租客姓名'] : '',
            lxdh: this.currentData['联系电话'] != null && this.currentData['联系电话'] != undefined ? this.currentData['联系电话'] : '',
            khh: this.currentData['开户行'] != null && this.currentData['开户行'] != undefined ? this.currentData['开户行'] : '',
            yhkh: this.currentData['银行卡号'] != null && this.currentData['银行卡号'] != undefined ? this.currentData['银行卡号'] : '',
            cjzq: this.currentData['成交周期'] != null && this.currentData['成交周期'] != undefined ? this.currentData['成交周期'] : 0,
            cfqd: this.currentData['出房渠道'] != null && this.currentData['出房渠道'] != undefined ? this.currentData['出房渠道'] : '中介',
            cffy: this.currentData['出房费用'] != null && this.currentData['出房费用'] != undefined ? this.currentData['出房费用'] : 0,
            cjyj: this.currentData['出房押金'] != null && this.currentData['出房押金'] != undefined ? this.currentData['出房押金'] : 0,
            ht_start: this.currentData['合同起始日'] != null && this.currentData['合同起始日'] != undefined ? this.currentData['合同起始日'] : '',
            ht_end: this.currentData['合同到期日'] != null && this.currentData['合同到期日'] != undefined ? this.currentData['合同到期日'] : '',
            cfzj: this.currentData['出房租金'] != null && this.currentData['出房租金'] != undefined ? this.currentData['出房租金'] : 0,
            zjzfzq: this.currentData['租金支付周期'] != null && this.currentData['租金支付周期'] != undefined ? this.currentData['租金支付周期'] : '按季',
            wykdf: this.currentData['物业费、宽带费'] != null && this.currentData['物业费、宽带费'] != undefined ? this.currentData['物业费、宽带费'] : 0,
            wykdzfzq: this.currentData['物业费、宽带费支付周期'] != null && this.currentData['物业费、宽带费支付周期'] != undefined ? this.currentData['物业费、宽带费支付周期'] : '季付',
            sdqyj: this.currentData['水电气押金'] != null && this.currentData['水电气押金'] != undefined ? this.currentData['水电气押金'] : 0,
            cwyj: this.currentData['宠物押金'] != null && this.currentData['宠物押金'] != undefined ? this.currentData['宠物押金'] : 0,
            tbyd: this.currentData['特别约定'] != null && this.currentData['特别约定'] != undefined ? this.currentData['特别约定'] : '',
            sfzyf: this.currentData['是否自用房'] != null && this.currentData['是否自用房'] != undefined ? this.currentData['是否自用房'] : '是'
          };
        }
        else if(name==="查看出租记录"){
          // this.initRecord("查看出租记录")
          // this.cleanPhotoList("身份证信息")
        
        }

      },
      //业务操作
      operate(name){
        if(name==="yd"){
          this.$refs[name].validate((valid) => {
          console.log("this.ghsfr==",this.ghsfr)
         if (valid) {
            let _this=this
            _this.$Modal.confirm({
              title: '确认提交提醒',
              content: `<br>请核实您输入的信息<br>`,
              onOk(){
                let param=_this.yd
                 param.id=_this.currentData.id
                 param["房源ID"]=_this.houseDetail.id
                zfglMethod_2_001.cfDczYd(param).then((res)=>{
                  console.log("更换收房人====",res)
                  if(res.data.step_0_update_res&&res.data.step_1_update_res&&res.data.step_2_update_res&&res.data.step_3_update_res){
                    _this.$Message.success("预定成功！")
                    _this.$emit("init")
                    _this.otherModal=false
               
                  }else{
                    _this.$Message.error(res.data.msg+"（请联系管理员）")
                  }
                })


              }})
         } else {
             this.$Message.error('请核实输入的内容!');
         }
        })
         
        }
        else if(name =='cz'){
          this.$refs[name].validate((valid) => {
          console.log("this.ghsfr==",this.ghsfr)
         if (valid) {
            let _this=this
            _this.$Modal.confirm({
              title: '确认提交提醒',
              content: `<br>请核实您输入的信息<br>`,
              onOk(){
                let param=_this.yd
                 param.id=_this.currentData.id
                 param["房源ID"]=_this.houseDetail.id
                // zfglMethod_2_001.cfDczYd(param).then((res)=>{
                //   console.log("更换收房人====",res)
                //   if(res.data.finallyRes){
                //     _this.$Message.success(res.data.msg)
                //     _this.$emit("init")
                //     _this.otherModal=false
               
                //   }else{
                //     _this.$Message.error(res.data.msg+"（请联系管理员）")
                //   }
                // })


              }})
         } else {
             this.$Message.error('请核实输入的内容!');
         }
        })
        }

      },

      getPhotoOnlyShow(data,oldSystemKey,father_table,father_id,type1,type2,showDataName){
        console.log("data===",data)
        console.log("data[oldSystemKey]===",data[oldSystemKey])
        let imgList = []
        if(data[oldSystemKey]!=null&&data[oldSystemKey]!=undefined){
          let oldImgList=JSON.parse(data[oldSystemKey])
          oldImgList.forEach((i)=>{
            imgList.push(this.imgBaseUrl+i.fileAddress)
          })
        }
        let params={
          father_table:father_table,
          father_id:father_id,
          type_1:type1,
          type_2:type2
        }
        fileMethod.selectFiles(params).then((res)=>{
          res.data.selectRes.forEach((i)=>{
            imgList.push("/xjby/view/"+i.show_path)
          })
          console.log("imgList==",imgList)
          this[showDataName] = imgList;
        })
    
         

      },
       // 新版清洗照片（新旧系统一起获取）（非房源版本）
       cleanPhotoListV3(key,father_table,father_id,type_1,type_2,old_data){
         
        let data= []
        //  新系统
        fileMethod.selectFiles({father_table:father_table,father_id:father_id,type_1:type_1,type_2:type_2}).then((res)=>{
          console.log(key,"--查询结果--",res)
         if(res.data.selectRes){
          res.data.selectRes.forEach((i)=>{
              let new_obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    source:"new_system",
                    id:i.id
                  }
                  data.push(new_obj);
            })
         } 
        })
        // 旧系统
        if(old_data.data_field_map==null||old_data.data_field_map==''||old_data.data_field_map==undefined){
          this.saveImage(key,data)
        }else{
          let data_field_map=JSON.parse(old_data.data_field_map)
          if (data_field_map[key]==""||data_field_map[key]==null||data_field_map[key]== undefined) {
            this.saveImage(key,data)
          }
          else{
            data_field_map[key].forEach((i)=>{
              let old_obj={
                show_name:"(旧系统)"+i.fileName,
                type_2:key,
                img:this.imgBaseUrl + i.fileAddress,
                suffix:i.fileType.split("/")[1], 
                source:"old_system",
                id:null
              }
              data.push(old_obj);
            })
            this.saveImage(key,data)
          }
        }
       
         
      },
       // 其他附件上传(前三个参数是文件信息，父表id，父表名称，类型1，类型2，key值绑定)
       async uploadSuccess(response, file, fileList,father_id,father_table, type_1,type_2,key) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name); 
        try { 
          let obj = {
          save_name: response.data.saveName,
          save_path: response.data.savePath,
          show_name: response.data.showName,
          show_path: response.data.showPath,
          suffix: response.data.suffix,
          type_1:type_1,
          type_2:type_2,
          bz:"new_system", 
          father_table:father_table,
          father_id:father_id
        };
        let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" +  response.data.saveName, localStorage.getItem('token'));
          obj.img_base64 = img_base64;
          zfglMethod_2_001.insertFileRecord(obj).then((res)=>{
      
            this.cleanPhotoListV3(type_1,father_table,father_id,type_1,null,this.currentData)
          })
  
        } catch (error) {
          console.error("Error fetching image as Base64:", error);
          // 处理错误，例如通知用户或设置默认值
        }
      },
     
      cleanData(obj, properties) { 
        // console.log("obj===",obj)
        properties.forEach(property => {
          delete obj[property];
        }); 
        return obj;
      },

      
      // 新版清洗照片（新旧系统一起获取）
      cleanPhotoListV2(key){
        let data= []
        //  新系统
        zfglMethod_2_001.getHousePhotosById({id:this.houseDetail.id,type_1:key,}).then((res)=>{
          console.log(key,"--查询结果--",res)
          res.data.list.forEach((i)=>{
              let new_obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    source:"new_system",
                    id:i.id
                  }
                  data.push(new_obj);
            })
        })
        // 旧系统
        if(this.houseDetail.data_field_map==null||this.houseDetail.data_field_map==''||this.houseDetail.data_field_map==undefined){
          this.saveImage(key,data)
        }else{
          let data_field_map=JSON.parse(this.houseDetail.data_field_map)
          if (data_field_map[key]==""||data_field_map[key]==null||data_field_map[key]== undefined) {
            this.saveImage(key,data)
          }
          else{
            data_field_map[key].forEach((i)=>{
              let old_obj={
                show_name:"(旧系统)"+i.fileName,
                type_2:key,
                img:this.imgBaseUrl + i.fileAddress,
                suffix:i.fileType.split("/")[1], 
                source:"old_system",
                id:null
              }
              data.push(old_obj);
            })
            this.saveImage(key,data)
          }
        }
       
         
      },
       // 新版清洗照片--房间照片专属(批量)（新旧系统一起获取）
       multipleCleanPhotoList(key,dataName){
        let data= []
        key.forEach((itemKey)=>{
        //  新系统
        zfglMethod_2_001.getHousePhotosById({id:this.houseDetail.id,type_1:itemKey,}).then((res)=>{
          console.log(key,"--查询结果--",res)
          res.data.list.forEach((i)=>{
              let new_obj={
                    show_name:i.show_name,
                    type_2:i.type_2,
                    img:"http://localhost:8080/xjby/view/" + i.show_path,
                    suffix:i.suffix, 
                    source:"new_system",
                    id:i.id
                  }
                  data.push(new_obj);
            })
        })
        // 旧系统
        if(this.houseDetail.data_field_map==null||this.houseDetail.data_field_map==''||this.houseDetail.data_field_map==undefined){
          return;
        }else{
          let data_field_map=JSON.parse(this.houseDetail.data_field_map)
          if (data_field_map[itemKey]==""||data_field_map[itemKey]==null||data_field_map[itemKey]== undefined) {
            return;
          }
          else{
            data_field_map[itemKey].forEach((i)=>{
              let old_obj={
                show_name:"(旧系统)"+i.fileName,
                type_2:itemKey,
                img:this.imgBaseUrl + i.fileAddress,
                suffix:i.fileType.split("/")[1], 
                source:"old_system",
                id:null
              }
              data.push(old_obj);
            })
            
          }
        }
        }) 
        this.saveImage(dataName,data)
         
      },
   
        
        // 存放照片
        saveImage(key,data){
      
          if(key==="房屋原貌"){ this.fwImgList=data }
          // if(key==="客厅照片"){ this.ktImgList=data }
          // else if(key==="卧室照片"){ this.wsImgList=data }
          // else if(key==="厨房照片"){ this.cfImgList=data }
          // else if(key==="卫生间照片"){ this.wsjImgList=data }
          // else if(key==="其他照片"){ this.qtImgList=data }

          else if(key==="房屋托管合同信息"){ this.fwtghtImgList=data }
          else if(key==="产证信息"){ this.czImgList=data }
          else if(key==="身份证信息"){ this.sfzImgList=data;  }
          else if(key==="授权委托书"){ this.sqhtsImgList=data } 
          else if(key==="预定凭证"){this.ydpzList=data}
          else if(key==="租客身份证信息"){this.zksfzList=data}
          else if(key==="租房合同信息"){this.zfhtList=data}

        },
        showImage(key){
          if(key==="房屋原貌"){return this.fwImgList ;}
          // else if(key==="卧室照片"){ return this.wsImgList ; }
          // else if(key==="厨房照片"){ return this.cfImgList ; }
          // else if(key==="卫生间照片"){ return this.wsjImgList ; }
          // else if(key==="其他照片"){ return this.qtImgList ; }

          else if(key==="房屋托管合同信息"){ return this.fwtghtImgList ;  }
          else if(key==="产证信息"){  return this.czImgList ; }
          else if(key==="身份证信息"){ return this.sfzImgList ;  }
          else if(key==="授权委托书"){ return this.sqhtsImgList ;  } 
          else{
            return [];
          }
        },
         // 房屋文件上传
      async uploadSuccess_house(response, file, fileList, name,imageType) {
        console.log("1上传成功fileList===", fileList);
        console.log("response===", response);
        console.log("file===", file);
        console.log("name===", name);

        

        try { 
          let obj = {
          save_name: response.data.saveName,
          save_path: response.data.savePath,
          show_name: response.data.showName,
          show_path: response.data.showPath,
          suffix: response.data.suffix,
          type_1:name,
          type_2:imageType?imageType:null,
          bz:"new_system", 
          father_table:"1_房源",
          father_id:this.houseDetail.id
        };
        let img_base64 = await utilTools.fetchImageAsBase64("/xjby/view/" +  response.data.saveName, localStorage.getItem('token'));
          obj.img_base64 = img_base64;
          zfglMethod_2_001.insertFileRecord(obj).then((res)=>{
            if (name === "产证信息") {
              // this.czImgList.push(obj);
              this.cleanPhotoList("产证信息")
            }
            else if(name === "身份证信息") {
              // this.sfzImgList.push(obj);
              this.cleanPhotoList("身份证信息")
            }
            else if(name === "房屋托管合同信息") {
              // this.fwtghtImgList.push(obj);
              this.cleanPhotoList("房屋托管合同信息")
            }
            else if(name === "房屋原貌") {
              this.cleanPhotoList("房屋原貌")
              // this.fwImgList.push(obj);
              // this.cleanPhotoList_fw("客厅照片")
              // this.cleanPhotoList_fw("卧室照片")
              // this.cleanPhotoList_fw("厨房照片")
              // this.cleanPhotoList_fw("卫生间照片")
              // this.cleanPhotoList_fw("其他照片")

            }
            else if(name === "授权委托书") {
              // this.sqhtsImgList.push(obj);
              this.cleanPhotoList("授权委托书")
            }
            else if(name === "shfjList") {
              this.shfjList.push(obj); 
            }
            else{
              
            }
          })
  
        } catch (error) {
          console.error("Error fetching image as Base64:", error);
          // 处理错误，例如通知用户或设置默认值
        }
      },
          // 在线预览文件
          watchFile(row,name) { 
        utilTools.downloadFromUrl(row.img, row.show_name, "open",localStorage.getItem('token'))
      },
      // 下载附件
        downloadFile(row,name) {
          utilTools.downloadFromUrl( row.img, row.show_name, "download",localStorage.getItem('token'))
      },
      // 删除预上传的附件 
      deleteFileBefore(row,name) {
        let _this=this
        this.$Modal.confirm({
        title: '确认删除提醒',
        content: `<br> 删除后不可恢复<br>`,
        onOk(){
          fileMethod.deleteFile({id:row.id}).then((res)=>{
            if(res.data.deleteRes===1){
              _this.$Message.success("删除成功")
              _this.cleanPhotoListV3(name,"1_收房收款计划",_this.currentData.id,name,null,_this.currentData)
              // _this.cleanPhotoListV3("租客身份证信息","1_收房收款计划",this.currentData.id,"租客身份证信息",null,this.currentData)
            }
          })

        }
      })
      },
        getHeight(value) {
          if (value == null) {
            return 50;
          }

        const processedValue = value.toString().replace(/\s+/g, ',');

          const length = processedValue.length; 
          const lines = Math.ceil(length / 28);
          return lines * 50;
        },
        changeZzrq(date){
        this.htzz.zzrq=date
      },
      // 新增收款计划相关操作
      // deleteRowBeforePost提交后台前，删除指定计划
      deleteRowBeforePost(index){
        removeElementByIndex(this.fkjhList, index)
      },
      // 显示收款计划
      initFkjh(){

      },
      // 自动生成收款计划
      createFkjh(){
        let successCount=0//设置成功循环的次数
        let currentCount=1//设置当前循环次数（设置为1是因为肯定至少要插入一次）
        this.fkjhLis=[]
        let propertiesList=['zkxm','lxdh','cjzq','cfqd','cffy','cjyj','ht_start','ht_end','cfzj','zjzfzq','wykdf','wykdzfzq','sdqyj']
        
        if(this.checkParams(this.cz,propertiesList)){
          // 0.获取出房管理数据
          let cfglData=this.currentData
          // 1.判断租金支付周期 '按季','按月','按半年','按年'
          let zfzq=[{label:"按月",value:1},{label:"按季",value:3},{label:"按半年",value:6},{label:"按年",value:12}].find((i)=>{return i.label==this.cz.zjzfzq}).value
          console.log("支付周期zfzq===",zfzq)
          successCount=zfzq
          // 2判断宽带/物业费支付周期
          let zfzq_wy=[{label:"月付",value:1},{label:"季付",value:3},{label:"半年付",value:6},{label:"年付",value:12}].find((i)=>{return i.label==this.cz.wykdzfzq}).value
          //3.计算第一笔付款金额(出房租金+出房管理费+水电气押金+宠物押金)其中出房管理费以出房管理表记录为准，其他数据以刚刚填入的信息为准
          let firstFkje=this.cz.cfzj+this.currentData['出房管理费']+this.cz.sdqyj+this.cz.cwyj
          // 3.1插入第一笔付款记录 （优先以输入的值为准，其次以出房管理表的记录为准），
          let params_3_1=this.currentData
          params_3_1['租客姓名']=this.cz.zkxm;
          params_3_1['合同起始日']=this.cz.ht_start;
          params_3_1['合同到期日']=this.cz.ht_end;
          params_3_1['第几次付款']=1;
          params_3_1['付款时间']=utilTools.adjustDate(this.cz.ht_start,1);
          params_3_1['付款金额']=firstFkje;  
          zfglMethod_2_001.addCffkjh(params_3_1).then((res)=>{
            if(res.data.insertRes==1){
              // 3.2设置提前15天起始日期（用于付款，付款一般是提前15天）
              let datBefore15=utilTools.adjustDate(this.cz.ht_start,-15);
              // 3.3设置付款周期（第二次开始的付款周期）
              console.log("this.cz==",this.cz)
              let fkList=utilTools.randBetweenMonths(this.cz.ht_start,this.cz.ht_end,this.cz.zfzq);
              console.log("fkList==",fkList)
              // 3.4 设置第几次付款初值
              let fkIndex=2;
               // 3.5 设置是否满年（满整年）
              //  let zfzq=this.cz.zfzq;//不写了，这里在第二步骤已经写过了

              //  3.6 循环付款日期
              for(let [index, item] of fkList.entries()){
                // 3.6.1 如果是最后一条，则终断掉
                let changeMonth=Number(-1*zfzq)
                console.log("zfzq==",zfzq)
                console.log("=Number(-1*zfzq)",Number(-1*zfzq))
                console.log("changeMonth==",changeMonth)
                if(utilTools.compareDates(item,utilTools.adjustDateByMonths(this.cz.ht_end,changeMonth))){
                  break;
                }
                //3.6.2租金周期与付款周期相同，新增付款记录，更新付款数index
                if(this.cz.zfzq==this.cz.wykdzfzq){
                  let params_3_6=this.currentData
                  params_3_6['租客姓名']=this.cz.zkxm;
                  params_3_6['合同起始日']=this.cz.ht_start;
                  params_3_6['合同到期日']=this.cz.ht_end;
                  params_3_6['第几次付款']=2+index;
                  params_3_6['付款时间']=utilTools.adjustDate(this.cz.ht_start,1);
                  params_3_6['付款金额']=this.cz.cfzj*this.cz.zfzq+this.currentData['出房管理费'];  
                  params_3_6['未收']=this.cz.cfzj*this.cz.zfzq+this.currentData['出房管理费'];  
                  params_3_6['实际收款金额']=this.cz.cfzj*this.cz.zfzq;  
                  zfglMethod_2_001.addCffkjh(params_3_6).then((res)=>{
                    if(res.data.insertRes!=1){
                      this.$Message.error("插入第"+(2+index)+"笔付款记录失败（200），请联系管理员。")
                    }else{
                      currentCount++
                      if(successCount==currentCount){
                        this.$Message.success("自动生成成功")
                        zfglMethod_2_001.selectCffkjh({id:this.currentData.id}).then((res)=>{
                          console.log("加载出房付款计划===",res)
                          this.fkjhList=res.data
                        })
                      }
                    }
                  })
                }else{//3.6.3租金周期与物业周期不同的情况
                  //3.6.3.1 如果是满年，则加上物业费
                  if(utilTools.MoD(zfzq,12)){
                    let params_3_6_3_1=this.currentData
                    params_3_6_3_1['租客姓名']=this.cz.zkxm;
                    params_3_6_3_1['合同起始日']=this.cz.ht_start;
                    params_3_6_3_1['合同到期日']=this.cz.ht_end;
                    params_3_6_3_1['第几次付款']=2+index;
                    params_3_6_3_1['付款时间']=utilTools.adjustDate(this.cz.ht_start,1);
                    params_3_6_3_1['付款金额']=this.cz.cfzj*this.cz.zfzq+this.currentData['出房管理费'];  
                    params_3_6_3_1['未收']=this.cz.cfzj*this.cz.zfzq+this.currentData['出房管理费'];  
                    params_3_6_3_1['实际收款金额']=this.cz.cfzj*this.cz.zfzq;  
                    zfglMethod_2_001.addCffkjh(params_3_6_3_1).then((res)=>{
                    if(res.data.insertRes!=1){
                      this.$Message.error("插入第"+(2+index)+"笔付款记录失败（200），请联系管理员。")
                    }else{
                      currentCount++
                      if(successCount==currentCount){
                        this.$Message.success("自动生成成功")
                        zfglMethod_2_001.selectCffkjh({id:this.currentData.id}).then((res)=>{
                          console.log("加载出房付款计划===",res)
                          this.fkjhList=res.data
                        })
                      }
                    }
                  })
                  }
                  else{ //3.6.3.2 如果不是满年，则不加物业费
                    let params_3_6_3_1=this.currentData
                    params_3_6_3_1['租客姓名']=this.cz.zkxm;
                    params_3_6_3_1['合同起始日']=this.cz.ht_start;
                    params_3_6_3_1['合同到期日']=this.cz.ht_end;
                    params_3_6_3_1['第几次付款']=2+index;
                    params_3_6_3_1['付款时间']=utilTools.adjustDate(this.cz.ht_start,1);
                    params_3_6_3_1['付款金额']=this.cz.cfzj*this.cz.zfzq;  
                    params_3_6_3_1['未收']=this.cz.cfzj*this.cz.zfzq;  
                    params_3_6_3_1['实际收款金额']=this.cz.cfzj*this.cz.zfzq;  
                    zfglMethod_2_001.addCffkjh(params_3_6_3_1).then((res)=>{
                    if(res.data.insertRes!=1){
                      this.$Message.error("插入第"+(2+index)+"笔付款记录失败（200），请联系管理员。")
                    }else{
                      currentCount++
                      if(successCount==currentCount){
                        this.$Message.success("自动生成成功")
                        zfglMethod_2_001.selectCffkjh({id:this.currentData.id}).then((res)=>{
                          console.log("加载出房付款计划===",res)
                          this.fkjhList=res.data
                        })
                      }
                    }
                  })
                  }
                  zfzq=zfzq+this.cz.zfzq
                }

              }


            }else{
              this.$Message.error("插入第一笔付款记录失败（100），请联系管理员。")
            }
          })
          if(successCount==currentCount){
            this.$Message.success("自动生成成功")
          }
        }else{
          this.$Message.error("自动生成失败(000)，请核查上方表格填入信息！或尝试手动输入。")
        }
      },
      // 手动新增收款计划
      addNewFkjh(){

      },
      // 自动付款验证
      checkParams(obj,propertiesList){
        for (const property of propertiesList) {
          if (obj[property] === undefined || obj[property] === null || obj[property] === '') {
            console.log("property==",property)
            console.log("obj[property]==",obj[property])
            return false;
          }
        }
        return true;
      },
      changeDateYdsj(date){
            // console.log("date==",date)
            this.yd.ydsj=date 
        },
        changeDateHtqsr(date){
            // console.log("date==",date)
            this.cz.ht_start=date 
        },
        changeDateHtdqr(date){
            // console.log("date==",date)
            this.cz.ht_end=date 
        },
        changeDateFksj(date){
            // console.log("date==",date)
            this.newFkjh.fksj=date 
        },
      cancel(){
        this.detailModal=false
      }
    }


}
</script>

  
  <style lang="scss" >
@import 'other_operate_modal_2_007.scss'; 

.base-modal{
        width: 100%;
        height: 700px;
        padding: 20px;
        .illustrate{
          width: 100%;
          height: 50px;
          line-height: 50px;
          display: flex;
          gap:20px;
        }
        .base-modal-line{
            width: 100%;
            height: auto;
            display: flex;
            gap:2%;
            align-items: center;
            justify-content: center;
            
            .item_1{
                width: 48%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_1-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_1-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            .item_2{
                width: 100%;
                height: auto;
                .item_2-title{
                    width: 100%;
                    color:#333333;
                }
            }
            .item_3{
                width: 100%;
                height: auto;
                display: flex; 
                font-size: 24px;  
                text-align: center;
                 line-height: 50px;
                 border-bottom: 1px solid #c3c3c3;
                 border-right: 1px solid #c3c3c3;
                 border-left: 1px solid #c3c3c3;
                .item_3-title{
                    width: 35%; 
                    height: auto;
                    color:#333333;
                    background-color: #cccccc;
                    
                }
                .item_3-value{
                    width: 65%;
                    color:#555555;
                    word-wrap: break-word; /* 允许长单词换行 */
                    word-break: break-all; /* 允许在任意字符处换行 */
                    overflow-wrap: break-word; /* 处理长单词换行 */
                }
               
                
            }
            

        }
        .box-1-2{
              width:100%;
              height: 100%;
              display: grid;
              grid-template-columns:50%  50%;
              
            }
    }
  </style>